import React from 'react';
import styles from './_not-authorized.module.scss';
const NotAuthorized: React.FC = () => {
  return (
    <div id='no-employee' className={styles.noEmployeeContainer}>
    <img src='/assets/not-authorized.jpg' alt='Not Authorized' className={styles.noEmployeeImage} />
    <h1 className={styles.noEmployeeTitle}>Not Authorized</h1>
    <p className={styles.noEmployeeParagraph}>
      You currently do not have the required permissions to access the website. <br />
      If you believe this is an error, please contact your local administrator.
    </p>
  </div>
  )
}

export default NotAuthorized;